import { Injectable } from '@angular/core';
import { Routes, Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';

@Injectable({
  providedIn: 'root'
})
export class RoutesManagerService {

  values: string[];

  constructor(private router: Router) {
    this.values = this.router.config.map((route: any) => route.path).filter(route => route !== '**');
  }


  setLocalRouteValue(nextRoute: string) {
    localStorage.setItem('current', nextRoute);
  }

  getCurrentRouteValue() {
    return localStorage.getItem('current');
  }

  getValueFor(aRoute: string) {
    return this.values.find(route => route === aRoute);
  }


}
